style= require('./match-times.styl')
.match-times
  if match.status === 'live'
    unless disablePause
      ft-button.pause.half(
        warning,
        (click)=this.updateStatus('paused', 'pause')
      ) Pause
    ft-button(
      danger,
      (click)=this.prompt('ended', 'end', 'Really end?')
    ) End
  else if match.status === 'paused'
    ft-button(
      success,
      (click)=this.updateStatus('live', 'unpause')
    ) Unpause
  else if match.status === 'ended'
    ft-button(
      danger,
      (click)=this.prompt('confirmed', 'confirm', 'Really CONFIRM?')
    ) Confirm Match
  else if match.status === 'confirmed'
    ft-button(success disabled) Confirmed
  else if startable
    ft-button(
      success,
      (click)=this.updateStatus('live', 'start')
    ) Start
  else
    ft-button(disabled) Pending
  ft-button.cancel(
    transparent,
    disabled=match.status === 'cancelled',
    (click)=this.cancel()
  ) Cancel

